export const ListColSectionsInspections = [
  {
    label: 'usage_details.created_by',
    width: 35,
  },
  {
    label: 'usage_details.time_of_creation',
    width: 30,
  },
  {
    label: 'usage_details.test_lab',
    width: 14,
  },
  {
    label: '',
    width: 9,
  },
];

export const ListColSectionsTestCases = [
  {
    label: 'usage_details.name',
    width: 16,
  },
  {
    label: 'usage_details.parallel_count',
    width: 4,
  },
  {
    label: 'usage_details.test_lab',
    width: 8,
  },
  {
    label: 'usage_details.type',
    width: 5,
  },
  {
    label: 'usage_details.triggered_by',
    width: 16,
  },
  {
    label: 'usage_details.duration_time',
    width: 15,
  },
  {
    label: 'usage_details.project_details',
    width: 13,
  },
  {
    label: '',
    width: 5,
  },
];

export const ListColSectionsDebuggingSession = [
  {
    label: 'usage_details.table_col.test_case_name',
    width: 30,
  },
  {
    label: 'usage_details.table_col.agent_name',
    width: 12,
  },
  {
    label: 'usage_details.triggered_by',
    width: 15,
  },
  {
    label: 'usage_details.duration_time',
    width: 15,
  },
  {
    label: 'usage_details.table_col.test_case_location',
    width: 15,
  },
  {
    label: '',
    width: 5,
  },
];
